/*
 * Copyright (c) 2020.  Sanish Manandhar
 * All Rights Reserved
 */

export const INVOICE_UPSERT_REQUEST = 'INVOICE_UPSERT_REQUEST';
export const INVOICE_UPSERT_REQUEST_SUCCESS = 'INVOICE_UPSERT_REQUEST_SUCCESS';
export const INVOICE_UPSERT_REQUEST_FAILURE = 'INVOICE_UPSERT_REQUEST_FAILURE';

export const INVOICE_FETCH_REQUEST = 'INVOICE_FETCH_REQUEST';
export const INVOICE_FETCH_REQUEST_SUCCESS = 'INVOICE_FETCH_REQUEST_SUCCESS';
export const INVOICE_FETCH_REQUEST_FAILURE = 'INVOICE_FETCH_REQUEST_FAILURE';

export const SINGLE_INVOICE_FETCH_REQUEST = 'SINGLE_INVOICE_FETCH_REQUEST';
export const SINGLE_INVOICE_FETCH_REQUEST_SUCCESS = 'SINGLE_INVOICE_FETCH_REQUEST_SUCCESS';
export const SINGLE_INVOICE_FETCH_REQUEST_FAILURE = 'SINGLE_INVOICE_FETCH_REQUEST_FAILURE';

export const INVOICE_VOID_REQUEST = 'INVOICE_VOID_REQUEST';
export const INVOICE_VOID_REQUEST_SUCCESS = 'INVOICE_VOID_REQUEST_SUCCESS';
export const INVOICE_VOID_REQUEST_FAILURE = 'INVOICE_VOID_REQUEST_FAILURE';

export const SINGLE_INVOICE_UPDATE_REQUEST = 'SINGLE_INVOICE_UPDATE_REQUEST';
export const SINGLE_INVOICE_UPDATE_REQUEST_SUCCESS = 'SINGLE_INVOICE_UPDATE_REQUEST_SUCCESS';
export const SINGLE_INVOICE_UPDATE_REQUEST_FAILURE = 'SINGLE_INVOICE_UPDATE_REQUEST_FAILURE';

export const INVOICE_FETCH_TAX_REQUEST = 'INVOICE_FETCH_TAX_REQUEST';
export const INVOICE_FETCH_TAX_REQUEST_SUCCESS = 'INVOICE_FETCH_TAX_REQUEST_SUCCESS';
export const INVOICE_FETCH_TAX_REQUEST_FAILURE = 'INVOICE_FETCH_TAX_REQUEST_FAILURE';

export const INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST = 'INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST';
export const INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST_SUCCESS =
  'INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST_SUCCESS';
export const INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST_FAILURE =
  'INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST_FAILURE';

export const INVOICE_TEMPLATE_FETCH_REQUEST = 'INVOICE_TEMPLATE_FETCH_REQUEST';
export const INVOICE_TEMPLATE_FETCH_REQUEST_SUCCESS = 'INVOICE_TEMPLATE_FETCH_REQUEST_SUCCESS';
export const INVOICE_TEMPLATE_FETCH_REQUEST_FAILURE = 'INVOICE_TEMPLATE_FETCH_REQUEST_FAILURE';

export const INVOICE_TEMPLATE_ITEMS_FETCH_REQUEST = 'INVOICE_TEMPLATE_ITEMS_FETCH_REQUEST';
export const INVOICE_TEMPLATE_ITEMS_FETCH_REQUEST_SUCCESS =
  'INVOICE_TEMPLATE_ITEMS_FETCH_REQUEST_SUCCESS';
export const INVOICE_TEMPLATE_ITEMS_FETCH_REQUEST_FAILURE =
  'INVOICE_TEMPLATE_ITEMS_SSFETCH_REQUEST_FAILURE';

export const INVOICE_TEMPLATE_UPSERT_REQUEST = 'INVOICE_TEMPLATE_UPSERT_REQUEST';
export const INVOICE_TEMPLATE_UPSERT_REQUEST_SUCCESS = 'INVOICE_TEMPLATE_UPSERT_REQUEST_SUCCESS';
export const INVOICE_TEMPLATE_UPSERT_REQUEST_FAILURE = 'INVOICE_TEMPLATE_UPSERT_REQUEST_FAILURE';

export const CLIENT_INVOICE_FETCH_REQUEST = 'CLIENT_INVOICE_FETCH_REQUEST';
export const CLIENT_INVOICE_FETCH_REQUEST_SUCCESS = 'CLIENT_INVOICE_FETCH_REQUEST_SUCCESS';
export const CLIENT_INVOICE_FETCH_REQUEST_FAILURE = 'CLIENT_INVOICE_FETCH_REQUEST_FAILURE';

export const INVOICE_UNPAID_COUNT_FETCH_REQUEST = 'INVOICE_UNPAID_COUNT_FETCH_REQUEST';
export const INVOICE_UNPAID_COUNT_FETCH_REQUEST_SUCCESS =
  'INVOICE_UNPAID_COUNT_FETCH_REQUEST_SUCCESS';
export const INVOICE_UNPAID_COUNT_FETCH_REQUEST_FAILURE =
  'INVOICE_UNPAID_COUNT_FETCH_REQUEST_FAILURE';

export const CLEAN_INVOICE_ERROR_PROPS = 'CLEAN_INVOICE_ERROR_PROPS';
export const CLEAN_INVOICE_LIST_PROPS = 'CLEAN_INVOICE_LIST_PROPS';
export const CLEAN_SINGLE_INVOICE_PROPS = 'CLEAN_SINGLE_INVOICE_PROPS';

export const INVOICE_PAYMENT_MODE_FETCH_REQUEST = 'INVOICE_PAYMENT_MODE_FETCH_REQUEST';
export const INVOICE_PAYMENT_MODE_FETCH_REQUEST_SUCCESS =
  'INVOICE_PAYMENT_MODE_FETCH_REQUEST_SUCCESS';
export const INVOICE_PAYMENT_MODE_FETCH_REQUEST_FAILURE =
  'INVOICE_PAYMENT_MODE_FETCH_REQUEST_FAILURE';

export const INVOICE_STATUS_FETCH_REQUEST = 'INVOICE_STATUS_FETCH_REQUEST';
export const INVOICE_STATUS_FETCH_REQUEST_SUCCESS = 'INVOICE_STATUS_FETCH_REQUEST_SUCCESS';
export const INVOICE_STATUS_FETCH_REQUEST_FAILURE = 'INVOICE_STATUS_FETCH_REQUEST_FAILURE';

export const INVOICE_SYNC_REQUEST = 'INVOICE_SYNC_REQUEST';
export const INVOICE_SYNC_REQUEST_SUCCESS = 'INVOICE_SYNC_REQUEST_SUCCESS';
export const INVOICE_SYNC_REQUEST_FAILURE = 'INVOICE_SYNC_REQUEST_FAILURE';

export const INVOICE_CHART_DATA_REQUEST = 'INVOICE_CHART_DATA_REQUEST';
export const INVOICE_CHART_DATA_REQUEST_SUCCESS = 'INVOICE_CHART_DATA_REQUEST_SUCCESS';
export const INVOICE_CHART_DATA_REQUEST_FAILURE = 'INVOICE_CHART_DATA_REQUEST_FAILURE';

export const CLEAN_INVOICE_TEMPLATE_PROPS = 'CLEAN_INVOICE_TEMPLATE_PROPS';

export const INVOICE_NOTIFICATION_RESEND = 'INVOICE_NOTIFICATION_RESEND ';
export const INVOICE_NOTIFICATION_RESEND_SUCCESS = 'INVOICE_NOTIFICATION_RESEND_SUCCESS';
export const INVOICE_NOTIFICATION_RESEND_FAILURE = 'INVOICE_NOTIFICATION_RESEND_FAILURE';
